export default __webpack_public_path__ + "static/media/1987.db61ed20.png";